import { MessageHandler, type IncomingMessage } from '@carvana/merch-native';
import {
  SebastianStatus,
  useSetSebastianStatus
} from '~/context/vdp/SebastianContext';
import { ListenerEvent, type ListenerEventType } from './constants';

type SebsReadinessPayload = { isLoaded: boolean };

function isSebsReadinessMessage(
  message: IncomingMessage<ListenerEventType, any>
): message is IncomingMessage<ListenerEventType, SebsReadinessPayload> {
  return (
    message.event === ListenerEvent.SebsReadiness &&
    typeof message.payload.isLoaded === 'boolean'
  );
}

export default function useSebsReadinessHandler(): MessageHandler<
  ListenerEventType,
  SebsReadinessPayload
> {
  const setSebastianStatus = useSetSebastianStatus();

  return new MessageHandler(isSebsReadinessMessage, message => {
    setSebastianStatus(
      message.payload.isLoaded ? SebastianStatus.Ready : SebastianStatus.Error
    );
  });
}
